import { getServerURL } from './getServerURL';

// compress: true krävs för fakturattest, men kan inte användas för bilder
export const uploadFile = (
  file: File,
  dbName: string,
  compress?: boolean
): Promise<string> => {
  const formData = new FormData();

  formData.append('myFile', file, file.name);
  formData.append('dbname', dbName);
  if (compress !== undefined) {
    formData.append('compress', compress.toString());
  }

  // Post to backend
  return fetch(`${getServerURL()}/blobupload`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  }).then(response => {
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    return response.text();
  });
};
